import React from 'react';
import {Upload, Icon, Button, Select, Row, Col} from 'antd';
const Option = Select.Option;
import download from '../../util/fileDownload';

class Document extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileList: [],
            setting: null
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.documents.length) {

            const fileList = nextProps.documents.map(({id: uid, file: {original_file_name: name, status = 'done'}, setting}) => {
                setting = setting && nextProps.settings.find(i => i.config.id === setting.id);
                name = `${setting ? setting.name + ' - ' : ''}${name}`;

                return {
                    uid,
                    name,
                    status,
                    url: nextProps.generateUrl(uid)
                }
            });
            return {fileList, loading: false, setting: null};
        }
        return {fileList: [], loading: false, setting: null};
    }
    handleChange(info) {
        this.setState({
            loading: info.file.status === 'uploading',
            fileList: [...info.fileList]
        });
    }
    onSelect(val) {
        this.setState({setting: val});
    }
    render() {
        const {onUpload, onRemove, settings} = this.props;
        const {fileList, setting, loading} = this.state;

        const onPreview = (file) => {
            const {url, name} = file;
            return download(url, name);
        };

        return (
            <div id="engineer-document">
                <Row gutter={16}>
                    <Col span={18}>
                        <Select onChange={this.onSelect.bind(this)} value={!setting ? '' : setting}>
                            {settings.map(({name, id, config}) => <Option value={config.id} key={id}>{name}</Option>)}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Upload
                            name="document"
                            data={{settings_id: setting}}
                            customRequest={onUpload}
                            onChange={this.handleChange.bind(this)}
                            onPreview={onPreview}
                            onRemove={onRemove}
                            fileList={fileList}
                        >
                            <Button disabled={loading || !setting}>
                                <Icon type='upload'/> Select file
                            </Button>
                        </Upload>
                    </Col>
                </Row>
            </div>
        )
    }
};

export default Document;


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/Document.js